module.exports = __webpack_public_path__ + "0b77ef778d84fdd0aa142b8e822d4883.png";